import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Route, Switch } from 'react-router';
import { ConnectedRouter } from 'connected-react-router';
import registerServiceWorker from './registerServiceWorker';
import './index.css';
import configureStore from './store/store';
import { Provider } from 'react-redux';
import App from './components/app/App';
import AppWithQuery from './components/app/AppWithQuery';
import { IntlProvider, FormattedNumber, addLocaleData } from 'react-intl'
import en from "react-intl/locale-data/en";
import es from "react-intl/locale-data/es";
import de from "react-intl/locale-data/de";

import 'primeicons/primeicons.css';
import 'primereact/resources/primereact.min.css';
import 'primereact/resources/themes/luna-blue/theme.css';


const messages_de = require('./translations/de.json');
const messages_en = require('./translations/en.json');

import { history } from './store/store'
import FNTDashboard from './components/app/FNTDashboard';
import TelemetryProvider from './appInsights/components/TelemetryProvider';

const messages = {
    'de': messages_de,
    'en': messages_en
};

let store = configureStore({});

addLocaleData([...en, ...es, ...de]);

const language =
    (navigator.languages && navigator.languages[0]) ||
    navigator.language;

ReactDOM.render(
    <Provider store={store}>
        <IntlProvider locale={language} messages={messages[language]}>
            <ConnectedRouter history={history}>
                <TelemetryProvider>
                    <div style={{bottom: '0px', top: '0', left: '0', right: '0' }}>
                        <Switch>
                                <Route exact={true} path="/" component={App} />
                                <Route exact={true} path="/report/:report?" component={App} />
                                <Route exact={true} path="/visual/:visual?" component={AppWithQuery} />
                                <Route exact={true} path="/fntDashboard" component={FNTDashboard} />
                        </Switch>
                    </div>
            </TelemetryProvider>
            </ConnectedRouter>
        </IntlProvider>
    </Provider>,
    document.getElementById('root') as HTMLElement
);

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.tsx